import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { TokenService } from '../../services/token.service';
import { map } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/auth/authentication.service';
import { ResultadoService } from 'src/app/services/resultado.service';
import { Conversion } from 'src/app/utils/convertBlob';


@Component({
  templateUrl: './resultado.component.html',
  styleUrls: ['./resultado.component.scss']
})

export class ResultadoComponent implements OnInit {

  token: string;
  mensagem: string = "Aguarde enquanto buscamos seu resultado...";
  siglaMarca: string = "";
  faviconMarca: HTMLLinkElement = document.querySelector('#faviconMarca');

  constructor(private activatedRoute: ActivatedRoute,
    private tokenService: TokenService, private auth: AuthenticationService,
    private resultadoService: ResultadoService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(
      params => {
        this.siglaMarca = params.siglaMarca;
        this.changeIcon();
      });

    this.activatedRoute.parent.queryParams.subscribe(params => {
      this.token = params.token;
    });

    this.auth.getAccessToken()
      .then(res => {
        this.validacaoToken()
          .then(conteudoToken => {
            if (conteudoToken)
              return this.obterResultadoPdf(conteudoToken);
          })
      })
  }

  obterResultadoPdf(conteudoToken) {
    return this.resultadoService.obterResultadoPdf(conteudoToken)
      .subscribe((res) => {
        if (res) {
          var resultado = JSON.parse(res);
          this.Convert(resultado.base64PDF);
          return this.resultadoService.resultadoVisualizado(conteudoToken)
            .subscribe(data => {
              this.mensagem = "Resultado visualizado com sucesso!";
            }, error => { console.log(error); });
        }
      }, error => {
          console.log(error);
          this.mensagem = "Ocorreu um erro no processamento, tente novamente!";
      });
  }

  Convert(file: any): void {
    const blob = Conversion.ConvertBase64toBlob(file, `application/pdf;charset=utf-8`, [file].length);
    window.open(window.URL.createObjectURL(blob), '_blank');
  }



  validacaoToken(): Promise<any> {
    return this.tokenService.validarToken(this.token)
      .pipe(
        map((response) => {
          return response;
        })
      )
      .toPromise()
      .then(data => { return this.processaResponseToken(data.body) })
      .catch(error => { return this.processaResponseToken(error.error) }
      );
  }

  processaResponseToken(data): any {
    if (data == null || data == undefined || data.valid == null || data.valid == undefined) {
      this.mensagem = "Ocorreu um erro no processamento, tente novamente!"
      return null;
    }

    if (data.valid) {
      return data.extraInfo;
    } else {
      if (data.error.name == "TokenExpiredError") {
        const dataExpiracao = new Date(data.error.expiredAt);
        const diaExpiracao = dataExpiracao.getDate();
        const mesExpiracao = dataExpiracao.getMonth() + 1;
        this.mensagem = "O seu token expirou em: " + (diaExpiracao < 10 ? "0" + diaExpiracao : diaExpiracao) +
          "/" + (mesExpiracao < 10 ? "0" + mesExpiracao : mesExpiracao) + "/" + dataExpiracao.getFullYear() + "!";
      }
      else {
        this.mensagem = "Token inválido para esta operação!"
      }
      return null;
    }
  }

  changeIcon() {
    this.faviconMarca.href = `./assets/images/favicon_${this.siglaMarca}.png`;
  }
}
